import { ButtonType } from "@components/atoms/Button/types";
import { ModalType } from "@components/atoms/Modal/types";

export type InputPopupProps = {
  title: string;
  buttons: {
    type: ButtonType;
    title: string;
    isLoadingButton: boolean;
    onPressAction: (data: object) => void;
  }[];
  description: string;
  showInput: boolean;
  isLoading: boolean;
  inputText?: string;
  notes?: string;
  styleKey?: string;
  isForEditSavedSearch?: boolean;
  showPopUpDialog?: boolean;
  setShowPopUpDialog?: (value: boolean) => void;
  modalType?: ModalType;
};

export type IconFrameProps = {
  backgroundColor: string;
};

export type PopupHeaderProps = {
  backgroundColor: string;
};

export enum messageType {
  Error = "Error",
  Success = "Success",
  Warning = "Warning",
}
